// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2p0ex","content":"styles_content__JRmff","selectAll":"styles_selectAll__K5ESB"};